// components/ZoomControls.jsx
import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Container = styled.div`
  position: absolute;
  top: 55px;
  right: 9px;
  display: flex;
  flex-direction: column;
  width: 36px;
  background: ${({ $theme }) => ($theme === "dark" ? "#1a1f2e" : "#ffffff")};
  border: 1px solid ${({ $theme }) => ($theme === "dark" ? "#252b3a" : "#e0e0e0")};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, ${({ $theme }) => ($theme === "dark" ? "0.4" : "0.12")});
  overflow: hidden;
  z-index: 5;
`

const Btn = styled.button`
  height: 36px;
  width: 100%;
  border: none;
  background: transparent;
  color: ${({ $theme }) => ($theme === "dark" ? "#e8eaf0" : "#1a1a1a")};
  font-size: 18px;
  font-weight: 300;
  cursor: pointer;
  transition: background 150ms ease;

  &:hover {
    background: ${({ $theme }) => ($theme === "dark" ? "#252b3a" : "#f5f5f5")};
  }

  &:focus {
    outline: 2px solid ${({ $primary }) => $primary || "#4f46e5"};
    outline-offset: -2px;
  }
`

const Divider = styled.div`
  height: 1px;
  background: ${({ $theme }) => ($theme === "dark" ? "#252b3a" : "#e0e0e0")};
`

const ZoomControls = ({ map, theme, primaryActionColor }) => {
  if (!map) return null

  const onZoomIn = () => {
    const next = (map.getZoom() || 0) + 1
    map.setZoom(next)
  }
  const onZoomOut = () => {
    const next = (map.getZoom() || 0) - 1
    map.setZoom(next)
  }

  return (
    <Container $theme={theme}>
      <Btn $theme={theme} $primary={primaryActionColor} onClick={onZoomIn} aria-label="Zoom in">
        +
      </Btn>
      <Divider $theme={theme} />
      <Btn $theme={theme} $primary={primaryActionColor} onClick={onZoomOut} aria-label="Zoom out">
        −
      </Btn>
    </Container>
  )
}

ZoomControls.propTypes = {
  map: PropTypes.object,
  theme: PropTypes.oneOf(["light", "dark"]),
  primaryActionColor: PropTypes.string,
}

ZoomControls.defaultProps = {
  map: null,
  theme: "light",
  primaryActionColor: "#4f46e5",
}

export default ZoomControls
